import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin, map } from 'rxjs';
import {
  IPatientCodelistRepository, PatientCodelistData,
} from '../../domain/repositories/patient-codelist.repository';
import { PatientCodelistRemoteDatasource } from '../datasources/remote/patient-codelist.remote-datasource';
import { PatientCodelistMapper } from '../mappers/patient-codelist.mapper';

@Injectable()
export class PatientCodelistRepositoryImpl implements IPatientCodelistRepository {
  private readonly datasource = inject(PatientCodelistRemoteDatasource);
  private readonly mapper = inject(PatientCodelistMapper);

  public getCodelists(): Observable<PatientCodelistData> {
    return forkJoin([
      this.datasource.getSpecies(), this.datasource.getBreeds(), this.datasource.getInsuranceCompanies(),
    ]).pipe(
      map(([speciesDtos, breedsDtos, insuranceCompaniesDtos]) => ({
        species: speciesDtos.map((dto) => this.mapper.toPatientCodelistItem(dto)),
        breeds: breedsDtos.map((dto) => this.mapper.toPatientCodelistItem(dto)),
        insuranceCompanies: insuranceCompaniesDtos.map((dto) => this.mapper.toPatientCodelistItem(dto)),
      })),
    );
  }
}
